var map = {
	"./Addresses/router.ts": "./src/Modules/Addresses/router.ts",
	"./Alerts/router.ts": "./src/Modules/Alerts/router.ts",
	"./AtrContracts/router.ts": "./src/Modules/AtrContracts/router.ts",
	"./Auth/router.ts": "./src/Modules/Auth/router.ts",
	"./BillingErrors/router.ts": "./src/Modules/BillingErrors/router.ts",
	"./Bills/router.ts": "./src/Modules/Bills/router.ts",
	"./CUR/router.ts": "./src/Modules/CUR/router.ts",
	"./Cups/router.ts": "./src/Modules/Cups/router.ts",
	"./Dashboard/router.ts": "./src/Modules/Dashboard/router.ts",
	"./FilesEditor/router.ts": "./src/Modules/FilesEditor/router.ts",
	"./History/router.ts": "./src/Modules/History/router.ts",
	"./Holidays/router.ts": "./src/Modules/Holidays/router.ts",
	"./LOPD/router.ts": "./src/Modules/LOPD/router.ts",
	"./Marketers/router.ts": "./src/Modules/Marketers/router.ts",
	"./Masters/router.ts": "./src/Modules/Masters/router.ts",
	"./NoContract/router.ts": "./src/Modules/NoContract/router.ts",
	"./Processes/router.ts": "./src/Modules/Processes/router.ts",
	"./ProcessesForms/router.ts": "./src/Modules/ProcessesForms/router.ts",
	"./Reports/router.ts": "./src/Modules/Reports/router.ts",
	"./S3Connector/router.ts": "./src/Modules/S3Connector/router.ts",
	"./Searcher/router.ts": "./src/Modules/Searcher/router.ts",
	"./UnprocessedFiles/router.ts": "./src/Modules/UnprocessedFiles/router.ts",
	"./UnprocessedMarketerFiles/router.ts": "./src/Modules/UnprocessedMarketerFiles/router.ts",
	"./User/router.ts": "./src/Modules/User/router.ts",
	"./UsersManager/router.ts": "./src/Modules/UsersManager/router.ts",
	"./Versioning/router.ts": "./src/Modules/Versioning/router.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Modules sync recursive router\\.ts$";